import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import EnvironmentOutlinedSvg from "@ant-design/icons-svg/es/asn/EnvironmentOutlined";
import AntdIcon from "../components/AntdIcon";
var EnvironmentOutlined = function EnvironmentOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EnvironmentOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  EnvironmentOutlined.displayName = 'EnvironmentOutlined';
}
export default /*#__PURE__*/React.forwardRef(EnvironmentOutlined);